import { render } from "./TableScrollComponent.vue?vue&type=template&id=0cde3d91"
import script from "./TableScrollComponent.vue?vue&type=script&lang=js"
export * from "./TableScrollComponent.vue?vue&type=script&lang=js"

import "./TableScrollComponent.vue?vue&type=style&index=0&id=0cde3d91&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__